import styled, { keyframes } from 'styled-components';

export const ContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  padding-top: 50px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 900px;
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;